import { FloatLabel } from "primereact/floatlabel";
import { TreeSelect } from "primereact/treeselect";
import { useEffect, useState } from "react";
import useApi from "../../Utils/BackendClient";
import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../components/content/CommonStyles.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { buildGroupHierarchy } from "../../Utils/Utils";

const ProductsAndServicesPickerSidebar = ({ sbVisible, onHide, type, onSelect}) => {

    const [loading, setLoading] = useState(false);
    const [productGroups, setProductGroups] = useState(null);
    const [products, setProducts] = useState(null);
    const [productsLazyState, setProductsLazyState] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: "created_at",
        sortOrder: 1,
        filters: {
            product_group: { value: null, matchMode: 'contains' }
        }
    });
    const [productsTotalRecords, setProductsTotalRecords] = useState(0);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [serviceGroups, setServiceGroups] = useState(null);
    const [services, setServices] = useState(null);
    const [servicesLazyState, setServicesLazyState] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: "created_at",
        sortOrder: 1,
        filters: {
            service_group: { value: null, matchMode: 'contains' }
        }
    });
    const [servicesTotalRecords, setServicesTotalRecords] = useState(0);

    const { fetchProducts, fetchProductsExtended, fetchServices, fetchServicesExtended } = useApi();

    useEffect(() => {

        const loadProductGroups = async () => {
            const response = await fetchProductsExtended();

            if (response.status === 200) {
                const groups = buildGroupHierarchy(response.data);
                setProductGroups(groups);
            }
        }

        const loadServiceGroups = async () => {
            const response = await fetchServicesExtended();

            if (response.status === 200) {
                const groups = buildGroupHierarchy(response.data);
                setServiceGroups(groups);
            }
        }

        loadProductGroups();
        loadServiceGroups();
    }, [fetchProductsExtended, fetchServicesExtended]);

    const setGroupValue = async (id) => {
        setSelectedGroup(id);
        setLoading(true);

        let filterGroup = null;

        if (id !== null && id !== undefined) {
            if (id.toString().includes('-')) {
                var keys = id.split('-');
                filterGroup = keys[(keys.length - 1)];
            }
            else {
                filterGroup = id;
            }
        }

        if (type === "products") {
            productsLazyState.filters.product_group.value = filterGroup;
        }
        else {
            servicesLazyState.filters.service_group.value = filterGroup;
        }

        const response = type === "products" ? await fetchProducts(true, productsLazyState) : await fetchServices(servicesLazyState);

        if (response.status === 200) {
            if (type === "products") {
                setProducts(response.data.results);
                setProductsTotalRecords(response.data.count);
            }
            else {
                setServices(response.data.results);
                setServicesTotalRecords(response.data.count);
            }

            setLoading(false);
        }
    }

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="text-xl text-900 font-bold">{tablename}</span>
            </div>
        );
    }

    const onProductsPage = event => {
        event.page = event.page + 1;
        setProductsLazyState(event);
    }

    const onServicePage = event => {
        event.page = event.page + 1;
        setServicesLazyState(event);
    }

    const actionBodyTemplate = (rowData) => {

        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-plus"
                type="button"
                className={`p-button-rounded ${commonStyle.addButton}`}
                tooltip="Додати"
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => onSelect(rowData)}
            />
        </div>
        );
    };

    return <Sidebar visible={sbVisible} onHide={onHide} position="right" className={commonStyle.sidebar}>
        {!selectedGroup && <label>Виберіть групу товарів для вибору товару</label>}
        <div className="p-inputgroup flex-column mt-4">
            <FloatLabel>
                <TreeSelect
                    name="set_group"
                    value={selectedGroup}
                    onChange={(e) => setGroupValue(e.value)}
                    options={type === "products" ? productGroups : serviceGroups}
                    className="w-full" />
                <label>Назва групи</label>
            </FloatLabel>
        </div>
        {type === "products" && <DataTable value={products} header={setTableHeader("Товари")} className="mt-4" rows={productsLazyState.rows} paginator onPage={onProductsPage} first={productsLazyState.first} loading={loading} totalRecords={productsTotalRecords} rowsPerPageOptions={[20, 50]}>
            <Column field="product_name" header="Назва продукту" />
            <Column field="action" body={actionBodyTemplate} />
        </DataTable>}
        {type === "services" && <DataTable value={services} header={setTableHeader("Послуги")} className="mt-4" rows={servicesLazyState.rows} paginator onPage={onServicePage} first={servicesLazyState.first} loading={loading} totalRecords={servicesTotalRecords} rowsPerPageOptions={[20, 50]}>
            <Column field="name" header="Назва послуги" />
            <Column field="action" body={actionBodyTemplate} />
        </DataTable>}
    </Sidebar>;
};

export default ProductsAndServicesPickerSidebar;